<template>
  <div class="d-flex pa-2">
    <ODialog ref="dialog">
      <v-card>
        <v-card-text class="pa-3 children-pa-3">
          <OTextarea
            v-model="copy.description"
            label="História do Cliente"
            :rows="10"
          />
        </v-card-text>
        <ODialogButtons class="pa-6" @apply="save" @cancel="dismissEdit" />
      </v-card>
    </ODialog>

    <div class="oderon-col-6 pa-2">
      <v-card>
        <ODialogBar title="História" no-close>
          <v-spacer />
          <v-btn icon @click="startEdit">
            <v-icon>edit</v-icon>
          </v-btn>
        </ODialogBar>
        <OLoadingLine absolute :value="isLoading" />
        <v-card-text>
          <p style="white-space: pre-line">{{ description }}</p>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import Store from './Store'

export default {
  data() {
    return {
      copy: {}
    }
  },
  computed: {
    description() {
      return Store.row.description || '─'
    },
    isLoading() {
      return Store.isLoading
    }
  },
  methods: {
    async startEdit() {
      this.copy = { description: Store.row.description }
      this.$refs.dialog.$open()
    },
    dismissEdit() {
      this.copy = {}
      this.$refs.dialog.$dismiss()
    },
    async save() {
      let what = { description: this.copy.description }
      this.dismissEdit()

      await Store.$loading(async () => {
        await Store.patch(what)
      })

      this.$snack('Salvo com sucesso')
    }
  }
}
</script>

<style lang="sass"></style>
